module.exports = __webpack_public_path__ + "img/yyrk-bg.6eb0f961.png";